var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 49,
    viewBox: "0 0 29 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_2133_547)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28.9998 7.85211V24.2127L20.9942 32.044L20.9697 32.0648V0L20.98 0.00695014L20.9942 0.0208504L28.9998 7.85211Z",
    fill: "url(#paint0_linear_2133_547)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.03008 49V16.9352L8.01903 16.9421L0 24.7873V41.1471L8.03008 49Z",
    fill: "url(#paint1_linear_2133_547)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.4867 42.3217V16.9336H8.03027L18.5129 6.67755V32.0656H20.9701L10.4867 42.3217Z",
    fill: "#9ECC3B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2133_547",
    x1: 24.9844,
    y1: 32.0648,
    x2: 24.9844,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#039543"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#27A241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#47AD3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#62B63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#78BE3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#89C43C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#95C83B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#9CCB3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9ECC3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2133_547",
    x1: 4.01464,
    y1: 49,
    x2: 4.01464,
    y2: 16.9352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9ECC3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#9CCB3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#95C83B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#89C43C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#78BE3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#62B63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#47AD3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#27A241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009444"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2133_547"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 49,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGreen);
export default __webpack_public_path__ + "static/media/logo_green.55de6ebf6df4ad4445b1459e8c271491.svg";
export { ForwardRef as ReactComponent };